import React from 'react'

export default function Footer() {
    return (
        <div className="footer-wrapper">
            <span style={{ "paddingBottom": "20px" }}>© Copyright 2020 Ventilator Registry Project</span>
        </div>
    )
}
